import { TextLink } from '@edsn/pie-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type {
  KnowledgeArticleListDto,
  KnowledgeArticleListDtoListResponse,
} from '#pie/internal/api/pie-bff';
import { Stack } from '../stack/Stack';
import { Text } from '../text/Text';
import { KnowledgeTabArticles } from './KnowledgeTabArticles';

interface KnowledgeTabAllProps {
  data: KnowledgeArticleListDtoListResponse | undefined;
  isLoading: boolean;
}

export const KnowledgeTabAll = ({ data, isLoading }: KnowledgeTabAllProps) => {
  const { t } = useTranslation();

  const groupedArticles = useMemo(() => {
    return (
      data?.items.reduce(
        (acc, article) => {
          if (acc[article.mainCategory.label]) {
            acc[article.mainCategory.label].push(article);
          } else acc[article.mainCategory.label] = [article];
          return acc;
        },
        {} as Record<string, KnowledgeArticleListDto[]>,
      ) ?? {}
    );
  }, [data?.items]);

  return (
    <>
      <KnowledgeTabArticles
        groupedArticles={groupedArticles}
        isLoading={isLoading}
      />
      <Stack className="mt-6 flex bg-surface-minimal-teal p-5 items-center">
        <div className="text-center">
          <Text variant="h2" as="h2" className="mb-2">
            {t('knowledge_base.banner.title')}
          </Text>
          <Text className="pb-4">
            {t('knowledge_base.banner.description')}{' '}
            <TextLink
              className="bg-transparent"
              href="mailto:info@partnersinenergie.nl"
            >
              info@partnersinenergie.nl
            </TextLink>
          </Text>
        </div>
      </Stack>
    </>
  );
};
